import { useCallback, useState, useEffect } from "react";
import { useLanderConfig } from "./ConfigContext";
import { postEvent } from "./EventHelper";
import { Settings } from "../config";
import { createBaseLanderEvent } from "./LanderEvent";

/**
 * A hook for firing events.
 * This helps with landerConfig dependency in useEffect.
 * triggerEvent is stable
 *
 * example:
 * const triggerEvent = useEventTrigger(eventType);
 * useEffect(() => {
 *   if (isEventVisible) {
 *     triggerEvent();
 *   }
 * }, [isEventVisible, triggerEvent]);
 */
const useEventTrigger = (eventType: string) => {
  const [pending, setPending] = useState(false);
  const { landerConfig } = useLanderConfig();

  useEffect(() => {
    if (!pending) return;

    setPending(false);

    postEvent(
      Settings.EVENT_PUBLISH_API,
      createBaseLanderEvent(eventType, landerConfig)
    );
  }, [eventType, landerConfig, pending]);

  const triggerEvent = useCallback(() => {
    setPending(true);
  }, []);

  return triggerEvent;
};

export default useEventTrigger;
